const STORAGE_KEY = 'eco-platform.last-used-org-id';

export function getLastUsedOrgId(): string | null {
  return window.localStorage.getItem(STORAGE_KEY);
}

export function setLastUsedOrgId(idpOrganisationId: string): void {
  window.localStorage.setItem(STORAGE_KEY, idpOrganisationId);
}

export function clearLastUsedOrgId(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}
